import React, { useRef, useState } from 'react';
import Header from '../Layouts/Header';
import Footer from '../Layouts/Footer';
import bgImage from '../Assets/Images/ServiceBg.jpeg';
import { FaArrowDown } from 'react-icons/fa';
import CircularText from '../Components/CircularText';
import { IoMdCloseCircle } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import toast, { Toaster } from 'react-hot-toast';
import { CORPORATETRAINING } from '../API/Config';


import trainingBg1 from '../Assets/Images/fullStackDevelopmentCourse.jpg';
import trainingBg2 from '../Assets/Images/CloudComputing.png';
import trainingBg3 from '../Assets/Images/DevOps.jpg'
import trainingBg4 from '../Assets/Images/Cybersecurity&EthicalHacking.jpg'
import trainingBg5 from '../Assets/Images/AIandMachineLearning.png'
import trainingBg6 from '../Assets/Images/MobileApp.jpg'
import trainingBg7 from '../Assets/Images/DatabaseManagement&SQL.png'
import trainingBg8 from '../Assets/Images/agileprojectmanagement.png'

const trainingCourses = [
  {
    title: "Full Stack Development",
    subtitle: "Java, .NET, MERN, MEAN",
    image: trainingBg1,
    description: "Master both front-end and back-end technologies to build complete web applications using popular stacks like MERN, MEAN, Java Spring Boot, and .NET."
  },
  {
    title: "Cloud Computing",
    subtitle: "AWS, Azure, Google Cloud",
    image: trainingBg2,
    description: "Learn to deploy, manage, and scale applications on leading cloud platforms with hands-on experience in AWS, Microsoft Azure, and Google Cloud."
  },
  {
    title: "DevOps & CI/CD",
    subtitle: "",
    image: trainingBg3,
    description: "Gain practical knowledge of continuous integration and continuous delivery using tools like Jenkins, Docker, Kubernetes, and GitLab for streamlined development and deployment."
  },
  {
    title: "Cybersecurity & Ethical Hacking",
    subtitle: "",
    image: trainingBg4,
    description: "Understand cybersecurity fundamentals, penetration testing, and ethical hacking techniques to protect systems and networks from vulnerabilities."
  },
  {
    title: "Data Science & AI/ML",
    subtitle: "",
    image: trainingBg5,
    description: "Explore data analysis, machine learning algorithms, and AI model building using Python, TensorFlow, and real-world datasets for data-driven decision making."
  },
  {
    title: "Mobile App Development",
    subtitle: "",
    image: trainingBg6,
    description: "Learn to build responsive, cross-platform mobile applications using Flutter, React Native, and native development tools for Android and iOS."
  },
  {
    title: "Database Management & SQL",
    subtitle: "",
    image: trainingBg7,
    description: "Understand database design, normalization, and querying using SQL with hands-on experience in MySQL, PostgreSQL, and NoSQL databases like MongoDB."
  },
  {
    title: "Agile / Scrum / Project Management",
    subtitle: "JIRA, Confluence",
    image: trainingBg8,
    description: "Develop skills in Agile methodologies, Scrum frameworks, and project tracking tools like JIRA and Confluence to manage software development efficiently."
  }
];

const CorporateTraining = () => {
  const scrollRef = useRef(null);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleScroll = () => {
    const section = document.getElementById('scrollDown');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollByOneCard = (direction) => {
    const card = scrollRef.current?.querySelector('div');
    if (card) {
      const cardWidth = card.offsetWidth + 24; // card width + gap (24px)
      scrollRef.current.scrollBy({ left: direction === 'right' ? cardWidth : -cardWidth, behavior: 'smooth' });
    }
  };

  const [formData, setFormData] = useState({
    fullname: '',
    phonenumber: '',
    email: '',
    course: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Validate phone number
    const phoneRegex = /^\+?[1-9]\d{1,14}$/;
    if (!phoneRegex.test(formData.phonenumber)) {
      toast.error('Please enter a valid phone number.');
      setIsSubmitting(false);
      return;
    }

    // Validate course selection
    if (!formData.course) {
      toast.error('Please select a course.');
      setIsSubmitting(false);
      return;
    }

    // Show loading toast
    const toastId = toast.loading('Submitting enrollment...');

    try {
      const response = await fetch(CORPORATETRAINING, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success('Enrollment submitted successfully!', { id: toastId });
        setFormData({
          fullname: '',
          phonenumber: '',
          email: '',
          course: '',
          message: '',
        });
      } else {
        toast.error(result.message || 'Failed to submit enrollment.', { id: toastId });
      }
    } catch (err) {
      toast.error('Error submitting enrollment. Please try again later.', { id: toastId });
      console.error('API Error:', err);
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <>
      <Header />

      {/* Hero Section */}
      <div
        className="relative min-h-screen flex flex-col justify-center items-center text-white"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        <div className="absolute inset-0 bg-black opacity-65"></div>

        <div className="relative z-10 text-center px-4 md:px-0 pb-32 space-y-4">
          <p className="text-xl md:text-2xl font-semibold tracking-wider">Corporate Training</p>
          <div className="mx-auto w-24 h-1 bg-white"></div>
          <h1 className="text-2xl md:text-4xl font-bold leading-tight">
            Knowledge grows when shared—train to lead.
          </h1>
        </div>

        <div className="relative flex items-center justify-center mt-10">
          <div
            onClick={handleScroll}
            className="absolute top-0 left-0 w-full h-full flex items-center justify-center cursor-pointer"
          >
            <CircularText text="VIVEKASOFTEK @ EXPLORE " spinDuration={20} />
          </div>
          <div className="z-10 flex items-center justify-center">
            <button onClick={handleScroll}>
              <FaArrowDown size={28} className="text-white" />
            </button>
          </div>
        </div>
      </div>

      {/* Training Programs Section */}
      <section className="bg-black text-white py-16 px-4" id="scrollDown">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center">Our Training Programs</h2>

          <div className="relative">
            {/* Left Arrow */}
            <button
              className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 p-2 text-black bg-white hover:bg-white/70 rounded-full"
              onClick={() => scrollByOneCard('left')}
            >
              <IoIosArrowBack />
            </button>

            {/* Scrollable Cards */}
            <div
              ref={scrollRef}
              className="flex gap-6 overflow-x-auto py-4 px-6 scroll-smooth scrollbar-hide"
              style={{
                scrollBehavior: 'smooth',
                scrollbarWidth: 'none', /* Firefox */
                msOverflowStyle: 'none', /* IE/Edge */
              }}
            >

              {trainingCourses.map((course, index) => (
                <div
                  key={index}
                  className="group min-w-[300px] h-[400px] rounded-xl relative shadow-lg flex-shrink-0 cursor-pointer overflow-hidden"
                  onClick={() => setSelectedCourse(course)}
                >
                  {/* Background image with zoom on hover */}
                  <div
                    className="absolute inset-0 bg-cover bg-center transition-transform duration-500 scale-100 group-hover:scale-110"
                    style={{ backgroundImage: `url(${course.image})` }}
                  ></div>

                  {/* Dark gradient overlay */}
                  <div
                    className="absolute inset-0 rounded-xl"
                    style={{
                      background:
                        "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0) 80%)",
                    }}
                  ></div>

                  {/* Text content */}
                  <div className="absolute bottom-0 p-4 text-left z-10">
                    <h3 className="text-xl font-bold text-white">{course.title}</h3>
                    {course.subtitle && (
                      <p className="text-sm text-gray-200">{course.subtitle}</p>
                    )}
                  </div>
                </div>


              ))}
            </div>

            {/* Right Arrow */}
            <button
              className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 p-2 text-black bg-white hover:bg-white/70 rounded-full"
              onClick={() => scrollByOneCard('right')}
            >
              <IoIosArrowForward />
            </button>
          </div>
        </div>
      </section>

      {/* Enroll Form Section */}
      <section className="bg-white text-black py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">Enroll Course</h2>
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block mb-2 text-sm font-medium">Full Name</label>
                <input
                  type="text"
                  name="fullname"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-black text-sm font-light"
                  required
                />
              </div>

              <div>
                <label className="block mb-2 text-sm font-medium">Phone Number</label>
                <input
                  type="tel"
                  name="phonenumber"
                  value={formData.phonenumber}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                  className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-black text-sm font-light"
                  required
                />
              </div>

              <div>
                <label className="block mb-2 text-sm font-medium">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-black text-sm font-light"
                  required
                />
              </div>

              <div>
                <label className="block mb-2 text-sm font-medium">Select Course</label>
                <select
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-black text-sm font-light"
                  required
                >
                  <option className="text-sm font-medium" value="" disabled>Select a course</option>
                  <option value="Full Stack Development">Full Stack Development</option>
                  <option value="Cloud Computing">Cloud Computing</option>
                  <option value="DevOps & CI/CD">DevOps & CI/CD</option>
                  <option value="Cybersecurity & Ethical Hacking">Cybersecurity & Ethical Hacking</option>
                  <option value="Data Science & AI/ML">Data Science & AI/ML</option>
                  <option value="Mobile App Development">Mobile App Development</option>
                  <option value="Database Management & SQL">Database Management & SQL</option>
                  <option value="Agile / Scrum / Project Management">Agile / Scrum / Project Management</option>
                </select>
              </div>

              <div className="md:col-span-2">
                <label className="block mb-2 text-sm font-medium">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Your message or course details"
                  className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-black text-sm font-light"
                />
              </div>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="bg-black text-white px-6 py-3 rounded hover:bg-gray-800 transition duration-300 text-sm font-light flex items-center justify-center mx-auto"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <svg
                    className="animate-spin h-5 w-5 mr-2"
                    viewBox="0 0 24 24"
                  >
                    <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="4" fill="none" />
                  </svg>
                )}
                {isSubmitting ? 'Submitting...' : 'Enroll'}
              </button>
            </div>
          </form>
        </div>
      </section>


      {/* Modal Section */}
      {selectedCourse && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
          <div className="bg-white w-full max-w-3xl rounded-lg overflow-hidden relative">
            <div
              className="h-72 bg-cover bg-center"
              style={{ backgroundImage: `url(${selectedCourse.image})` }}
            >
              <button
                className="absolute top-4 right-4 text-black text-3xl font-bold z-10"
                onClick={() => setSelectedCourse(null)}
              >
                <IoMdCloseCircle />
              </button>
            </div>
            <div className="p-6">
              <h2 className="text-2xl font-bold mb-2">{selectedCourse.title}</h2>
              {selectedCourse.subtitle && <p className="text-sm text-gray-700 mb-3">{selectedCourse.subtitle}</p>}
              <p className="text-gray-800 font-normal">{selectedCourse.description}</p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default CorporateTraining;
